import React from 'react';
import { useWebsiteSettings } from '../hooks/useWebsiteSettings';
import { GraduationCap, Zap } from 'lucide-react';

const Logo = ({ className = "h-12 w-auto", linkTo = "/" }) => {
  const { settings } = useWebsiteSettings();

  // Stylish animated logo
  return (
    <a href={linkTo} className="flex items-center gap-2 sm:gap-3 group">
      {/* Animated Icon Container */}
      <div className="relative flex-shrink-0">
        {/* Glow effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-xl blur-md opacity-60 group-hover:opacity-100 transition-opacity duration-300"></div>
        
        {/* Main icon box */}
        <div className="relative w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110 group-hover:rotate-3">
          <GraduationCap className="w-5 h-5 sm:w-6 sm:h-6 text-white drop-shadow-md" />
        </div>
        
        {/* Animated spark */}
        <div className="absolute -top-1 -right-1 w-3.5 h-3.5 sm:w-4 sm:h-4 bg-gradient-to-r from-yellow-300 via-orange-400 to-red-500 rounded-full animate-bounce shadow-lg flex items-center justify-center">
          <Zap className="w-2 h-2 sm:w-2.5 sm:h-2.5 text-white" />
        </div>
      </div>
      
      {/* Text with gradient and effects */}
      <div className="flex flex-col min-w-0">
        <span className="text-lg sm:text-2xl font-extrabold tracking-tight">
          <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">Skill</span>
          <span className="bg-gradient-to-r from-purple-600 via-pink-500 to-rose-500 bg-clip-text text-transparent">Edge</span>
        </span>
        <span className="text-[8px] sm:text-[10px] font-medium text-gray-500 tracking-widest uppercase -mt-1">Learn • Grow • Excel</span>
      </div>
    </a>
  );
};

export default Logo;
